import Axios from 'axios'
import Group from 'model/Group'
import GroupMember from 'model/GroupMember'
import LastViewedPatient from 'model/LastViewedPatient'
import PatientMessage from 'model/PatientMessage'
const { server } = (window as any).config

export default class GeneralApi {
  static sendPatientMessage(patientMessage: PatientMessage) {
    return Axios.post(server + '/patient_messages', patientMessage)
  }

  static acknowledgePatientMessage(messageAcknowledgeList: PatientMessage[]) {
    return Axios.post(server + '/patient_messages/acknowledge', messageAcknowledgeList)
  }

  static addMemberToGroup(groupMember: GroupMember) {
    return Axios.post(server + '/group_members', groupMember)
  }

  static removePatientFromGroup(groupMember: GroupMember) {
    return Axios.delete(server + '/group_members/' + groupMember._id)
  }

  static findRemovePatientFromGroup(groupMember: GroupMember) {
    return Axios.delete(
      server + '/group_members/group/' + groupMember.groupId + '/patient/' + groupMember.patientId,
    )
  }

  static findRemoveUserFromGroup(groupMember: GroupMember) {
    return Axios.delete(
      server + '/group_members/group/' + groupMember.groupId + '/user/' + groupMember.userId,
    )
  }

  static deleteGroup(groupId: string) {
    return Axios.delete(server + '/groups/' + groupId)
  }

  static fetchGroupPatients(group: Group) {
    return Axios.post(server + '/group_members/patients/', { groupId: group.id })
  }

  static fetchGroupUsers(group: Group) {
    return Axios.post(server + '/group_members/users/', { groupId: group.id })
  }

  static saveLastViewedPatients(lastViewedPatients: LastViewedPatient[]) {
    return Axios.post(server + '/users/lastViewedPatients', { lastViewedPatients })
  }

  static getLastViewedPatients() {
    return Axios.get(server + '/users/lastViewedPatients')
  }

  static getUserNameAvailability(userId: string, userName: string, role: string) {
    return Axios.get(
      server + '/users/userNameAvailable/' + `${userId}/${userName}` + `?role=${role}`,
    )
  }

  static async getPatientUserNameAvailability(patientId: string, userName: string) {
    return Axios.get(server + '/patients/userNameAvailable/' + `${patientId}/${userName}`)
  }

  static async getPatientIdentityCodeAvailability(patientId: string, identityCode: string) {
    return Axios.get(server + '/patients/identityCodeAvailable/' + `${patientId}/${identityCode}`)
  }

  static getGroupNameAvailability(groupId: string, groupName: string) {
    return Axios.get(server + '/groups/groupNameAvailable/' + `${groupId}/${groupName}`)
  }

  static uploadPatientFile(data: any) {
    return Axios.post(server + '/patients_files/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
  static uploadPatientEditFile(data: any) {
    return Axios.post(server + '/patients_files/uploadEditFile', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  static generatePerscription(data: any) {
    return Axios.post(server + '/pdf/perscription', data)
  }

  static getPrimaryDoctors() {
    return Axios.get(server + '/patients/getPrimaryDoctor')
  }

  static generateAppointmentSummery(data: any) {
    return Axios.post(server + '/pdf/appointment_summery', data)
  }

  static fetchPerscriptions(data: any) {
    return Axios.post(server + '/patients_files/perscriptions', data)
  }

  static isEmrUsersEmpty() {
    return Axios.get(server + '/users/empty')
  }

  static getPatientJwtToken(patientId: string) {
    return Axios.get(server + `/patients/${patientId}/getQrToken`)
  }

  static verifyPatientJwtToken(jwtToken: any) {
    return Axios.post(server + `/patients/verifyQrToken`, jwtToken)
  }

  static sendUsernameSms(patientId: string) {
    return Axios.post(server + `/patients/sendUsernameSms`, { patientId: patientId })
  }
  static sendZohoTicket(ZohoTicket: object) {
    return Axios.post(server + `/sendZohoTicket`, ZohoTicket)
  }
  static async getImage(url: string) {
    let res = await Axios.get(url, {
      responseType: 'blob',
    })
    return new Blob([res.data], { type: 'application/pdf' })
  }
}
